import { TParadiseLLMPromptCategory } from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"
import { arrayIncludes } from "src/utils/genericUtil"

export const validParadiseLLMPromptsCategories: TParadiseLLMPromptCategory[] = [
  "guest_message_input_sanitization",
  "guest_message_response",
  "guest_message_output_sanitization",
]

export function parseParadiseLLMPromptsCategory(
  category: string | undefined
): TParadiseLLMPromptCategory | undefined {
  if (
    !category ||
    !arrayIncludes(validParadiseLLMPromptsCategories, category)
  ) {
    return undefined
  }

  return category
}

export function isVaildParadiseLLMPromptsCategory(
  category: string | undefined
): category is TParadiseLLMPromptCategory {
  return !!parseParadiseLLMPromptsCategory(category)
}
